import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsRoute: InvariantJiraRoute = {
	name: 'assets',
	path: '/jira/assets',
	exact: true,
};
